// i18n keys: testimonials.items.1 … testimonials.items.35 (must exist in bg.json and en.json)

export type TestimonialSource = 'google' | 'chat' | 'phone' | 'viber' | 'omnilinks'

export interface TestimonialMeta {
  id: string
  source: TestimonialSource
  initial: string
  avatarColor: string
}

const TESTIMONIALS_BY_ID: Record<string, TestimonialMeta> = {
  '1': { id: '1', source: 'google', initial: 'С', avatarColor: '#D82268' },
  '2': { id: '2', source: 'google', initial: 'В', avatarColor: '#1E6B8A' },
  '3': { id: '3', source: 'google', initial: 'T', avatarColor: '#2D8A6E' },
  '4': { id: '4', source: 'google', initial: 'Y', avatarColor: '#C45C26' },
  '5': { id: '5', source: 'google', initial: 'R', avatarColor: '#6B5B95' },
  '6': { id: '6', source: 'google', initial: 'G', avatarColor: '#E07B39' },
  '7': { id: '7', source: 'google', initial: 'Y', avatarColor: '#4A90A4' },
  '8': { id: '8', source: 'google', initial: 'D', avatarColor: '#8FBC8F' },
  '9': { id: '9', source: 'google', initial: 'K', avatarColor: '#D4A017' },
  '10': { id: '10', source: 'google', initial: 'Y', avatarColor: '#708090' },
  '11': { id: '11', source: 'google', initial: 'M', avatarColor: '#B565A7' },
  '12': { id: '12', source: 'google', initial: 'R', avatarColor: '#009B77' },
  '13': { id: '13', source: 'google', initial: 'V', avatarColor: '#DD4124' },
  '14': { id: '14', source: 'google', initial: 'Д', avatarColor: '#45B8AC' },
  '15': { id: '15', source: 'google', initial: 'T', avatarColor: '#EFC050' },
  '16': { id: '16', source: 'google', initial: 'L', avatarColor: '#5B5EA6' },
  '17': { id: '17', source: 'google', initial: 'R', avatarColor: '#9B2335' },
  '18': { id: '18', source: 'google', initial: 'G', avatarColor: '#7B6D8D' },
  '19': { id: '19', source: 'chat', initial: 'С', avatarColor: '#55B4B0' },
  '20': { id: '20', source: 'chat', initial: 'А', avatarColor: '#E15D44' },
  '21': { id: '21', source: 'chat', initial: 'Ю', avatarColor: '#7FCDCD' },
  '22': { id: '22', source: 'chat', initial: 'Е', avatarColor: '#BC243C' },
  '23': { id: '23', source: 'chat', initial: 'И', avatarColor: '#98B4D4' },
  '24': { id: '24', source: 'chat', initial: 'Ц', avatarColor: '#C3447A' },
  '25': { id: '25', source: 'chat', initial: 'А', avatarColor: '#317873' },
  '26': { id: '26', source: 'chat', initial: 'Н', avatarColor: '#3D5A80' },
  '27': { id: '27', source: 'phone', initial: 'Е', avatarColor: '#F4845F' },
  '28': { id: '28', source: 'phone', initial: 'н', avatarColor: '#A05195' },
  '29': { id: '29', source: 'phone', initial: 'И', avatarColor: '#2EC4B6' },
  '30': { id: '30', source: 'phone', initial: 'С', avatarColor: '#FF6B6B' },
  '31': { id: '31', source: 'phone', initial: 'Д', avatarColor: '#4ECDC4' },
  '32': { id: '32', source: 'phone', initial: 'Р', avatarColor: '#FFE066' },
  '33': { id: '33', source: 'phone', initial: 'н', avatarColor: '#6A0572' },
  '34': { id: '34', source: 'omnilinks', initial: 'Е', avatarColor: '#AB83A1' },
  '35': { id: '35', source: 'viber', initial: 'А', avatarColor: '#264653' },
}

/** Carousel display order — interleaved by channel (max 1 consecutive from same source). */
const TESTIMONIAL_DISPLAY_ORDER = [
  '1', '19', '2', '20', '3', '27', '4', '21', '5', '28',
  '6', '22', '7', '29', '8', '23', '9', '30', '10', '24',
  '11', '31', '12', '25', '13', '32', '14', '26', '15', '33',
  '16', '34', '17', '35', '18',
] as const

export const TESTIMONIALS: TestimonialMeta[] = TESTIMONIAL_DISPLAY_ORDER.map(
  id => TESTIMONIALS_BY_ID[id]!,
)

export const TESTIMONIAL_RATING_SCORE = '5/5'
